import * as React from 'react';
import styled, { css } from 'styled-components';
import { palette } from '../../theme/colors';
import { TextField, TextFieldType } from '../TextField/TextField';

export type DynamicFormFieldType = {
  id?: string;
  type?: TextFieldType;
  placeHolder: string;
  placeHoldertx?: string;
  value: string;
  visible: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  onClick?: (e: React.SyntheticEvent) => void;
};

type STextFieldParams = {
  $clickable?: boolean;
};

const STextField = styled(TextField)<STextFieldParams>`
  margin-bottom: 0.625rem;

  input {
    ${props =>
      props.$clickable &&
      css`
        :hover {
          cursor: pointer;
        }
      `}
    color: ${palette.white};
    font-family: 'Roboto-Regular';
    font-weight: 400;
    font-size: 0.9rem;
    overflow: hidden;
    text-overflow: ellipsis !important;
  }
`;
type IMemberSettingsDynamicFormProps = {
  fields: DynamicFormFieldType[];
  handlePhoneClick?: (phone: string) => void;
  handleEmailClick?: (email: string) => void;
};

const MemberSettingsDynamicForm = (props: IMemberSettingsDynamicFormProps) => {
  const { fields } = props;
  return (
    <div>
      {fields.map((field, index) => {
        return field.visible ? (
          <STextField
            key={String(index)}
            id={field.id}
            type={field.type || TextFieldType.TEXT}
            value={field.value || ''}
            disabled
            onChange={field.onChange}
            onBlur={field.onBlur}
            readOnly={!field.onChange}
            placeholder={field.placeHolder}
            touched={false}
            onClick={field.onClick}
            $clickable={!!field.onClick}
            role={`textField-${field.type || TextFieldType.TEXT}`}
          />
        ) : null;
      })}
    </div>
  );
};

export default MemberSettingsDynamicForm;
